import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/plastic.css'; // Assuming you are already using a custom CSS file
import Acer1 from '../assets/images/acer (1).jpg';
import Acer2 from '../assets/images/acer-2.jpg';
import Acer3 from '../assets/images/acer-3.jpg';
import Acer4 from '../assets/images/acer-4.jpg';
import Acer5 from '../assets/images/acer-5.jpg';
import Acer6 from '../assets/images/acer-6.jpg';

const Acer = () => {
  const [customStyle, setCustomStyle] = useState(false); // Track the style toggle

  const images = [
    Acer1,
    Acer2,
    Acer3,
    Acer4,
    Acer5,
    Acer6,
  ];

  // Toggle custom styling
  const switchStyle = () => {
    setCustomStyle(!customStyle);
  };

  return (
    < div >
      <section className="about-container"> <h1>Acer</h1></section>
      <br/><br/>
     <div className="acer-container" >
      {/* Gallery with hover animation */}
      <div className={`row ${customStyle ? "hover-effect-2" : "hover-effect-1"}`} id="gallery">
        {images.map((src, index) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
            <img
              className="w-100 hover-img"
              src={src}
              alt={`Slide ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Acer;
